<div>
    <div class="make-responsive-tracker uni-entitylist">
    <mat-card class="example-card cursor uni-mat-card vehicle-state-card" [style.background-color]= "((selectedVehicleState && selectedVehicleState?.includes(state?.key) && (selectedVehicleState?.[0] === 'allVehicle'? true : trackerFilters)) || (trackerFilters?.operationalStatus?.includes(state.key)) ) ? state?.selectedBgColor : state?.backgroundColor"
     *ngFor="let state of states">
      <mat-card-content (click)="handleVehicleState(state?.key)">
        <div class="box padt-10 padb-10">
          <div class="widget-title" [style.color]="((selectedVehicleState && selectedVehicleState?.includes(state?.key) && (selectedVehicleState?.[0] === 'allVehicle' ? true : trackerFilters)) || (trackerFilters?.operationalStatus?.includes(state.key))) ? state?.selectedFontColor : state?.textColor">
            {{state?.name}}
          </div>
          <div class="widget-value" [style.color]="((selectedVehicleState && selectedVehicleState?.includes(state?.key) && (selectedVehicleState?.[0] === 'allVehicle' ? true : trackerFilters)) || (trackerFilters?.operationalStatus?.includes(state.key))) ? state?.selectedFontColor : state?.textColor">
            {{ state?.value ??  0 }}
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  </div>